import { PORTFOLIO_TYPE } from '@/constants'

import { Fees, Section, Space } from '../../../../../../components/core-v2'
import { formatFees } from '../../../../util'
import { StyledCharges } from '../../../01-note/existing-note/details-summary/primitives'
import { NoteStepState } from '../../../01-note/note/note-step-slice'
import { PortfolioStepState } from '../../../03-portfolio/state/portfolio-slice'
import { StrategyStepState } from '../../../04-strategy/state/strategy-slice'
import { ApprovalBox } from '../../molecules/approval-box'
import { ConfirmationBox } from '../../molecules/confirmation-box'
import { ApprovalProps } from './types'

type Props = ApprovalProps & {
  note: NoteStepState
  portfolio: PortfolioStepState
  strategy: StrategyStepState
}

export const ApproveFees = ({
  isApproved,
  note,
  onChangeIsApproved,
  portfolio,
  strategy
}: Props) => {
  const isModelOrFundOfFunds =
    portfolio.portfolioType === PORTFOLIO_TYPE.ModelPortfolio.key ||
    portfolio.portfolioType === PORTFOLIO_TYPE.FundOfFunds.key
  const portfolioFees = isModelOrFundOfFunds ? portfolio.model?.portfolio?.fees : []

  return (
    <ApprovalBox isApproved={isApproved} title="Charges">
      <Space mb={5}>
        <Section type="secondary">
          <StyledCharges>
            <Fees fees={formatFees(note.note?.fees)} title="Note Charges" />
          </StyledCharges>
        </Section>
      </Space>
      <Space mb={5}>
        <Section type="secondary">
          <StyledCharges>
            <Fees fees={formatFees(portfolioFees)} title="Portfolio Charges" />
          </StyledCharges>
        </Section>
      </Space>
      <Space mb={5}>
        <Section type="secondary">
          <StyledCharges>
            <Fees
              fees={strategy.strategyFees?.[strategy?.selectedStrategy.id]}
              title="Strategy Charges"
            />
          </StyledCharges>
        </Section>
      </Space>
      <ConfirmationBox
        elementTitle="Charges"
        isApproved={isApproved}
        isAre="are"
        onChangeIsApproved={onChangeIsApproved}
      />
    </ApprovalBox>
  )
}
